// src/components/HomePage.jsx
import React, { useState, useEffect } from 'react';
import HeroSlider from '../components/HeroSlider';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    fetchAllDoctors, storeRequestCallback, fetchAllSpecialities, fetchFilterOPD,
    searchDoctors, fetchHomeCardList, fetchHomePageAboutSLRahejaList, fetchHomePageDoctorsList,
    fetchHomePageSpecialtyList, fetchHomePageCorporateLogoList, fetchHomePageTpaLogoList,
} from "../Adapter/PageAdapter";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Toaster, toast } from 'sonner';
import { Helmet } from "react-helmet-async";
import { fetchHomePageSeo } from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
import DoctorAppointmentModal from "../components/DoctorAppointmentModal";
import newArrImg from "../assets/images/arrw.svg";
import CheckIcon from '@mui/icons-material/Check';
import Frame1 from '../assets/images/Frame1.png';
import Frame2 from '../assets/images/Frame2.png';
import health from '../assets/images/healthblk.png';
import frame4 from '../assets/images/frame4blk.png';
import BlackArrow from '../assets/images/black-arr.png';
import WhiteArrow from '../assets/images/rightarw-svg.svg';
import About2 from '../assets/images/about2.png';
import About3 from '../assets/images/about3.png';
import diabeticImg from '../assets/images/diabetic-foot-svg.svg';
import cardiacImg from '../assets/images/heart (3) 1.svg';
import oncologyImg from '../assets/images/oncology 1.svg';
import nurologyImg from '../assets/images/nurology.svg';
import OrthopaedicsImg from '../assets/images/orthopedics 1.svg';
import urologyImg from '../assets/images/urology 1.svg';
import emergencyImg from '../assets/images/medical-service 1.svg';
import gastroImg from '../assets/images/gastroenterology 1.svg';
import googleImg from '../assets/images/google.png';
import LG1 from '../assets/images/clogo1.jpg';
import LG2 from '../assets/images/clogo2.jpg';
import LG3 from '../assets/images/clogo3.jpg';
import LG4 from '../assets/images/clogo4.jpg';
import LG5 from '../assets/images/clogo5.jpg';
import DLG1 from '../assets/images/tplogo1.jpg';
import DLG2 from '../assets/images/tplogo2.jpg';
import DLG3 from '../assets/images/tplogo3.jpg';
import DLG4 from '../assets/images/tplogo4.jpg';
import DLG5 from '../assets/images/tplogo5.jpg';
import DLG6 from '../assets/images/tplogo6.jpg';
import Doct1 from '../assets/images/drarun.png';
import Doct2 from '../assets/images/Suresh-advani.png';
import Doct3 from '../assets/images/drharesh.png';
import Doct4 from '../assets/images/drvinay.png';
import VectorIcon from '../assets/images/Vector.png';
import PatientTech from '../components/PatientTech';
import PatientStory from '../components/PatientStory';
import InformationEvents from '../components/InformationEvents';
import map from '../assets/images/mapbg.png';
import { Nav } from 'react-bootstrap';
import popupImg from "../assets/images/newPopimg.jpeg";

const HomePage = () => {
    const navigate = useNavigate();

    const [doctors, setDoctors] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isManuallyOpened, setIsManuallyOpened] = useState(false);
    const [specialties, setSpecialties] = useState([]);
    const [doctorsList, setDoctorsList] = useState([]);
    const [seoData, setSeoData] = useState(null);
    const [homeCards, setHomeCards] = useState([]);
    const [aboutRahejaContent, setAboutRahejaContent] = useState(null);
    const [homeDoctors, setHomeDoctors] = useState([]);
    const [appointmentDoctor, setAppointmentDoctor] = useState(null);
    const [homeSpecialties, setHomeSpecialties] = useState([]);
    const [corporateLogos, setCorporateLogos] = useState([]);
    const [tpaLogos, setTpaLogos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        // Show popup on homepage load
        setShowPopup(true);
    }, []);

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const fetchSeo = async () => {
            const response = await fetchHomePageSeo();
            console.log("SEO Data Home", response);
            if (response) setSeoData(response);
        };
        fetchSeo();
    }, []);

    useEffect(() => {
        if (!seoData?.custom_scripts) return;

        const decodeHtmlEntities = (html) => {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = html;
            return textarea.value;
        };

        const decoded = decodeHtmlEntities(seoData.custom_scripts).trim();

        const match = decoded.match(
            /<script[^>]*type=["']?(.*?)["']?[^>]*>([\s\S]*?)<\/script>/i
        );

        let type = "text/javascript";
        let content = decoded;

        if (match) {
            type = match[1] || "text/javascript";
            content = match[2].trim();
        }

        // Detect JSON-LD type
        const isJsonLd =
            type === "application/ld+json" ||
            (content.trim().startsWith("{") && content.trim().endsWith("}"));

        if (isJsonLd) {
            try {
                JSON.parse(content);
                type = "application/ld+json"; // Override type just in case
            } catch (e) {
                console.error("Invalid JSON-LD:", e);
                return;
            }
        } else if (content.trim().startsWith("{")) {
            console.error("Detected JSON but not using application/ld+json.");
            return;
        }

        const script = document.createElement("script");
        script.type = type;
        script.id = "seo-custom-script";
        script.text = content;

        const existing = document.getElementById("seo-custom-script");
        if (existing) existing.remove();

        document.head.appendChild(script);

        return () => {
            const el = document.getElementById("seo-custom-script");
            if (el) el.remove();
        };
    }, [seoData?.custom_scripts]);

    useEffect(() => {
        const getCards = async () => {
            const res = await fetchHomeCardList();
            if (res?.data) setHomeCards(res.data);
        };
        getCards();
    }, []);

    useEffect(() => {
        const getAbout = async () => {
            const res = await fetchHomePageAboutSLRahejaList();
            console.log("About API response:", res);
            if (res?.data) {
                setAboutRahejaContent(res.data); // NOT res.data[0], since it's an object
            }
        };
        getAbout();
    }, []);

    useEffect(() => {
        const getDoctors = async () => {
            const res = await fetchHomePageDoctorsList();
            if (res?.data) setHomeDoctors(res.data);
        };
        getDoctors();
    }, []);

    useEffect(() => {
        const getSpecialties = async () => {
            const res = await fetchHomePageSpecialtyList();
            if (res?.data) setHomeSpecialties(res.data);
        };
        getSpecialties();
    }, []);

    useEffect(() => {
        const getCorporateLogos = async () => {
            const res = await fetchHomePageCorporateLogoList();
            if (res?.data) setCorporateLogos(res.data);
        };
        getCorporateLogos();
    }, []);

    useEffect(() => {
        const getTpaLogos = async () => {
            const res = await fetchHomePageTpaLogoList();
            if (res?.data) setTpaLogos(res.data);
        };
        getTpaLogos();
    }, []);

    // Fetch doctors when a specialty is selected
    const handleSpecialtyList = async (e) => {
        const specialityId = e.target.value;
        setFormData({
            ...formData,
            speciality_id: specialityId,
            doctor_id: "",
        });

        try {
            const response = await fetchFilterOPD(specialityId);
            if (response && response.data) {
                setDoctorsList(response.data);
            } else {
                setDoctorsList([]);
            }
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    };

    useEffect(() => {
        const fetchSpecialties = async () => {
            try {
                const response = await fetchAllSpecialities();
                if (response && response.specialities) {
                    setSpecialties(response.specialities);
                }
            } catch (error) {
                console.error("Error fetching specialties:", error);
            }
        };
        fetchSpecialties();
    }, []);

    const [formData, setFormData] = useState({
        patientName: "",
        contact_number: "",
        email: "",
        message: "",
        appointment_date: "",
        doctor_id: "",
        doctor_name: "",
        speciality_id: "",
        speciality_name: "",
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // Only allow numbers and plus in contact number
        if (name === "contact_number" || name === "countryCode") {
            const sanitizedValue = value.replace(/(?!^)\+/g, "").replace(/[^0-9+]/g, "");
            setFormData({ ...formData, [name]: sanitizedValue });
            return;
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleOpenModal = () => {
        setShowModal(true);
        setIsManuallyOpened(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);

        // Manually remove Bootstrap modal-related classes
        document.body.classList.remove("modal-open");

        // Remove the modal backdrop if it exists
        const modalBackdrops = document.getElementsByClassName("modal-backdrop");
        while (modalBackdrops.length > 0) {
            modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
        }
    };

    useEffect(() => {
        if (!isManuallyOpened) {  // Only trigger the timer if not manually opened
            const timer = setTimeout(() => {
                setShowModal(true);
            }, 15000000);

            return () => clearTimeout(timer); // Cleanup timer on component unmount
        }
    }, [isManuallyOpened]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (loading) return;

        setLoading(true);

        const selectedDoctor = doctorsList.find(
            (doc) => parseInt(doc.id) === parseInt(formData.doctor_id)
        );
        const selectedSpeciality = specialties.find(
            (spec) => parseInt(spec.id) === parseInt(formData.speciality_id)
        );

        const payload = {
            patient_name: formData.patientName,
            contact_number: formData.contactNo,
            email: formData.email,
            message: formData.message,
            appointment_date: formData.date,
            speciality_id: formData.speciality_id,
            doctor_id: formData.doctor_id,
            doctor_name: selectedDoctor?.doctor_name || "",
            speciality_name: selectedSpeciality?.name || "",
        };

        const crmPayload = {
            first_name: payload.patient_name?.split(" ")[0],
            last_name: payload.patient_name?.split(" ")[1] || "",
            phone: payload.contact_number,
            email: payload.email,
            message: payload.message,
            leadsource: "Doctor Appointment Form Homepage",
            fortis_doctor_name: payload.doctor_name,
            referred_for_specilaity: payload.speciality_name,
            expected_admission_date: payload.appointment_date,
        };

        try {
            const response = await storeRequestCallback(payload);
            console.log("Full submission result:", response); // ⬅️ Add this

            const backendOk = response?.backendResult?.message?.toLowerCase().includes("success");
            const crmOk = response?.crmResult?.status === "success";

            if (backendOk && crmOk) {
                toast.success("Request submitted successfully!");
            } else {
                toast.success("Request submitted successfully!");
            }

            setFormData({
                patientName: "",
                contactNo: "",
                email: "",
                speciality_id: "",
                doctor_id: "",
                date: "",
                message: "",
            });
            setDoctorsList([]);
            handleCloseModal();

        } catch (error) {
            console.error("Submission error:", error);
            toast.error("An error occurred. Please try again.");
        }
        finally {
            setLoading(false);
        }
    };

    // Handle Share Click
    const handleShare = (doctor) => {
        const doctorProfileUrl = `${window.location.origin}/doctor/${doctor.slug}`;
        if (navigator.share) {
            navigator
                .share({
                    title: `Check out Dr. ${doctor.name}`,
                    text: `Learn more about Dr. ${doctor.name}, a specialist in ${doctor.speciality}.`,
                    url: doctorProfileUrl,
                })
                .catch((error) => console.error("Error sharing:", error));
        } else {
            alert("Sharing is not supported in this browser.");
        }
    };

    return (
        <>

            {seoData && (
                <Helmet>
                    <title>{seoData.seo_title}</title>
                    <meta name="title" content={seoData.meta_title} />
                    <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
                    <meta name="keywords" content={seoData.meta_keywords} />

                    <meta property="og:title" content={seoData.og_title} />
                    <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
                    <meta property="og:type" content={seoData.og_type} />
                    <meta property="og:url" content={seoData.og_url} />
                    <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
                    <meta property="og:locale" content={seoData.og_locale} />
                    <meta property="og:site_name" content={seoData.og_site_name} />
                    <meta property="article:modified_time" content={seoData.article_modified_time} />

                    <meta name="twitter:card" content={seoData.twitter_card} />
                    <meta name="twitter:title" content={seoData.twitter_title} />
                    <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
                    <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
                    <meta name="twitter:site" content={seoData.twitter_site} />

                    <link rel="canonical" href={seoData.canonical_link} />

                    {/* Custom scripts injection */}
                   {/*  {seoData.custom_scripts && (
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
                    )} */}
                </Helmet>
            )}

            <HeroSlider />

            {/* Appointments Section */}
            <Toaster position="top-right" />
            {appointmentDoctor && (
                <DoctorAppointmentModal doctor={appointmentDoctor} onClose={() => setAppointmentDoctor(null)} />
            )}

            {/* Homepage Popup */}
	    {/* {showPopup && (
                <div
                    className="popup-overlay"
                    style={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 2000,
                    }}
                >
                    <div
                        className="popup-content"
                        style={{
                            position: "relative",
                            background: "#fff",
                            padding: "10px",
                            borderRadius: "8px",
                            maxWidth: "450px",
                            width: "75%",
                        }}
                    >
                        <button
                            onClick={handleClosePopup}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                border: "1px solid #000",
                                background: "#fff",
                                fontSize: "20px",
                                cursor: "pointer",
                                padding: "1px 10px",
                            }}
                        >
                            &times;
                        </button>
                        <img
                            src={popupImg}
                            alt="Popup Banner"
                            style={{ width: "100%", borderRadius: "6px" }}
                        />
                    </div>
                </div>
            )} */}
	    
            <section className="appoint">
                <div className="cust-container">
                    {/* <div className="appoint-cards">
                        <div className="row">
                            {isMobile ? (
                                // Only show "FIND A DOCTOR" card on mobile
                                <div className="col-md-12">
                                    <div className="card-app light-green">
                                        <div className="appoit-box">
                                            <div className="icon"><img src={Frame2} alt="" /></div>
                                            <h3>FIND A DOCTOR</h3>
                                        </div>
                                        <p>Explore our expert doctors across various specialities.</p>
                                        <NavLink to="/doctor" className="with-arr">Learn More <img src={BlackArrow} alt="" /> </NavLink>
                                    </div>
                                </div>
                            ) : (
                                // Show all 4 cards on desktop
                                <>
                                    <div className="col-md-3">
                                        <div className="card-app light-green">
                                            <div className="appoit-box">
                                                <div className="icon"><img src={Frame1} alt="" /></div>
                                                <h3>BOOK AN APPOINTMENT</h3>
                                            </div>
                                            <p>Schedule your visit with our specialists at your convenience.</p>
                                            <a href="#" onClick={handleOpenModal} className="with-arr">Learn More <img src={BlackArrow} alt="" /></a>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card-app light-green">
                                            <div className="appoit-box">
                                                <div className="icon"><img src={Frame2} alt="" /></div>
                                                <h3>FIND A DOCTOR</h3>
                                            </div>
                                            <p>Explore our expert doctors across various specialities.</p>
                                            <NavLink to="/doctor" className="with-arr">Learn More <img src={BlackArrow} alt="" /> </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card-app green">
                                            <div className="appoit-box">
                                                <div className="icon"><img src={health} alt="" /></div>
                                                <h3>HEALTH CHECK UP</h3>
                                            </div>
                                            <p>Get reassurance with expert insights on your health.</p>
                                            <NavLink to="/health-checkup" className="with-arr">Learn More <img src={BlackArrow} alt="" /> </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card-app green">
                                            <div className="appoit-box">
                                                <div className="icon"><img src={frame4} alt="" /></div>
                                                <h3>ONLINE CONSULTATION</h3>
                                            </div>
                                            <p>Easily book your appointment anytime, anywhere.</p>
                                            <a href="#" onClick={handleOpenModal} className="with-arr">Learn More <img src={BlackArrow} alt="" /></a>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div> */}
                    <div className="appoint-cards">
                        <div className="row">
                            {isMobile ? (
                                // Only show "Find a Doctor" card on mobile
                                homeCards
                                    .filter((card) => card.heading.toLowerCase().includes("doctor"))
                                    .map((card) => (
                                        <div className="col-md-12" key={card.id}>
                                            <div className="card-app light-green">
                                                <div className="appoit-box">
                                                    <div className="icon">
                                                        <img src={`${baseImage_path}/${card.icon}`} alt={card.heading} />
                                                    </div>
                                                    <h3>{card.heading}</h3>
                                                </div>
                                                <p>{card.sub_heading}</p>
                                                <NavLink
                                                    to={card.redirect_link ? `/${card.redirect_link}` : "/doctor"}
                                                    className="with-arr"
                                                >
                                                    Learn More <img src={BlackArrow} alt="" />
                                                </NavLink>
                                            </div>
                                        </div>
                                    ))
                            ) : (
                                homeCards.map((card, index) => (
                                    <div className="col-md-3" key={card.id}>
                                        <div className={`card-app ${index % 2 === 0 ? "light-green" : "green"}`}>
                                            <div className="appoit-box">
                                                <div className="icon">
                                                    <img src={`${baseImage_path}/${card.icon}`} alt={card.heading} />
                                                </div>
                                                <h3>{card.heading}</h3>
                                            </div>
                                            <p>{card.sub_heading}</p>
                                            {card.redirect_link && card.redirect_link !== "null" ? (
                                                <NavLink to={`/${card.redirect_link}`} className="with-arr">
                                                    Learn More <img src={BlackArrow} alt="" />
                                                </NavLink>
                                            ) : (
                                                <a href="#" onClick={handleOpenModal} className="with-arr">
                                                    Learn More <img src={BlackArrow} alt="" />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* About Us Section */}
            <section className="section towr-work">
                <div className="cust-container">
                    {/* <div className="aboutraheja-sec-inner">
                        <div className="about-raheja-sec-colfst">
                            <div className="finnest">
                                <h5>ABOUT  S.L.  RAHEJA</h5>
                                <h3>We Provide Finest
                                    Patient's <span><b>Care & Amenities</b></span></h3>
                                <p>For over four decades, S.L. Raheja Hospital – A  Fortis Associate, has been providing world-class health care services to the people of Mumbai. Our commitment to comprehensive service across specialties like diabetology, oncology, cardiology, oncology, neurology, orthopedics, and many others remains steadfast.</p>
                                <NavLink to="/about" className="btn with-color with-arr"> <img src={WhiteArrow} alt="" />
                                    More About Us</NavLink>
                                <div className="go-rt">
                                    <img src={googleImg} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="about-raheja-sec-colscnd">
                            <div className="tower-img">
                                <img src={About2} alt="" />
                                <div className="pat-rev">
                                    <div className="bck-bor">
                                        <h4>10k+</h4>
                                        <p>PATIENT'S <br /> REVIEWS</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="about-raheja-sec-colthrd">
                            <div className="doct-team">
                                <img src={About3} alt="" />
                                <div className="doct-deta">
                                    <h6>Why Choose S.L. Raheja Hospital?</h6>
                                    <div className="check-list">
                                        <ul>
                                            <p> <CheckIcon /> 43 Years of Expertise</p>
                                            <p> <CheckIcon /> Comprehensive Multispecialty Care</p>
                                            <p> <CheckIcon /> State-of-the-Art Facilities</p>
                                            <p> <CheckIcon /> Experienced Medical Team</p>
                                            <p> <CheckIcon /> Accredited Excellence</p>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {aboutRahejaContent && (
                        <div className="aboutraheja-sec-inner">
                            <div className="about-raheja-sec-colfst">
                                <div className="finnest">
                                    <h5>{aboutRahejaContent.title}</h5>
                                    <h3 dangerouslySetInnerHTML={{ __html: aboutRahejaContent.left_heading }} />
                                    <p>{aboutRahejaContent.left_content}</p>
                                    <NavLink to="/about-us" className="btn with-color with-arr">
                                        <img src={WhiteArrow} alt="" />
                                        More About Us
                                    </NavLink>
                                    <div className="go-rt">
                                        <img src={googleImg} alt="Google Reviews" />
                                    </div>
                                </div>
                            </div>

                            <div className="about-raheja-sec-colscnd">
                                <div className="tower-img">
                                    <img
                                        src={`${baseImage_path}/${aboutRahejaContent.main_img}`}
                                        alt="Main About Image"
                                    />
                                    <div className="pat-rev">
                                        <div className="bck-bor">
                                            <h4>{aboutRahejaContent.patient_review}</h4>
                                            <p>PATIENT'S <br /> REVIEWS</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="about-raheja-sec-colthrd">
                                <div className="doct-team">
                                    <img
                                        src={`${baseImage_path}/${aboutRahejaContent.right_img}`}
                                        alt="Doctors Team"
                                    />
                                    <div className="doct-deta">
                                        <h6>{aboutRahejaContent.right_heading.replace(/\?{2,}/g, '?')}</h6>
                                        <div className="check-list">
                                            <ul>
                                                {aboutRahejaContent.right_content
                                                    .match(/<li>(.*?)<\/li>/g)
                                                    ?.map((item, index) => {
                                                        const text = item.replace(/<\/?li>/g, ""); // strip <li> tags
                                                        return (
                                                            <li key={index}>
                                                                <CheckIcon /> {text}
                                                            </li>
                                                        );
                                                    })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>

            {/* Specialties Section */}
            <section className="section specialties">
                <div className="specail">
                    <div className="cust-container">
                        <h2 className="section-title">Comprehensive Care Across a <span>Spectrum of Specialties</span></h2>
                        {/* <div className="spec-card homeSpace">
                            {isMobile ? (
                                <Swiper
                                    modules={[Autoplay]}
                                    spaceBetween={16}
                                    slidesPerView={1.2}
                                    autoplay={{ delay: 250000 }}
                                    loop={true}
                                >
                                    {[
                                        {
                                            title: "Diabetology & Diabetic Foot Surgery",
                                            img: diabeticImg,
                                            desc: "Expert care for managing diabetes and preventing complications, including advanced diabetic foot surgery.",
                                            link: "/specialities/diabetology-diabetic-foot-surgery",
                                        },
                                        {
                                            title: "Cardiac Science",
                                            img: cardiacImg,
                                            desc: "Comprehensive heart care, from diagnostics to surgeries, ensures the best outcomes for various heart conditions.",
                                            link: "/specialities/cardiac-sciences",
                                        },
                                        {
                                            title: "Oncology",
                                            img: oncologyImg,
                                            desc: "Personalised cancer treatment with the latest therapies, including chemotherapy and surgery to fight cancer.",
                                            link: "/specialities/oncology",
                                        },
                                        {
                                            title: "Neurology & Neurosurgery",
                                            img: nurologyImg,
                                            desc: "Expert care for neurological disorders, offering advanced treatments and surgeries.",
                                            link: "/specialities/neurology-neurosurgery",
                                        },
                                        {
                                            title: "Orthopaedics",
                                            img: OrthopaedicsImg,
                                            desc: "Advanced care for bone, joint, and spine conditions with minimally invasive surgeries and tailored rehabilitation.",
                                            link: "/specialities/orthopaedics",
                                        },
                                        {
                                            title: "Urology",
                                            img: urologyImg,
                                            desc: "Specialised treatment for urinary and reproductive health issues.",
                                            link: "/specialities/urology",
                                        },
                                        {
                                            title: "Emergency Medicine and Critical Care",
                                            img: emergencyImg,
                                            desc: "24/7 emergency care with immediate life-saving interventions, supported by advanced equipment.",
                                            link: "/specialities/emergency-medicines-critical-care",
                                        },
                                        {
                                            title: "Gastroenterology",
                                            img: gastroImg,
                                            desc: "Expert care for digestive and liver disorders using advanced treatments.",
                                            link: "/specialities/gastro-intestinal-science",
                                        },
                                    ].map((spec, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="card-end">
                                                <div className="card-end-body">
                                                    <div className="cardi-img">
                                                        <img src={spec.img} alt={spec.title} />
                                                    </div>
                                                    <h3>{spec.title}</h3>
                                                    <p>{spec.desc}</p>
                                                </div>
                                                <NavLink to={spec.link} className="btn with-arr with-arr">
                                                    Read More <img src={BlackArrow} alt="" />
                                                </NavLink>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            ) : (
                                <div className="row">
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={diabeticImg} alt="Endocrinology Icon" />
                                                </div>
                                                <h3>Diabetology & Diabetic Foot Surgery</h3>
                                                <p>Expert care for managing diabetes and preventing complications,
                                                    including advanced diabetic foot surgery.</p>
                                            </div>
                                            <NavLink to="/specialities/diabetology-diabetic-foot-surgery" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={cardiacImg} alt="Cardiology Icon" />
                                                </div>
                                                <h3>Cardiac Science</h3>
                                                <p>Comprehensive heart care, from diagnostics to surgeries,
                                                    ensures the best outcomes for various heart conditions.</p>
                                            </div>
                                            <NavLink to="/specialities/cardiac-sciences" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={oncologyImg} alt="Oncology Icon" />
                                                </div>
                                                <h3>Oncology</h3>
                                                <p>Personalised cancer treatment with the latest therapies,
                                                    including chemotherapy and surgery to fight cancer.</p>
                                            </div>
                                            <NavLink to="/specialities/oncology" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={nurologyImg} alt="Neurology Icon" />
                                                </div>
                                                <h3>Neurology & Neurosurgery</h3>
                                                <p>Expert care for neurological disorders,
                                                    offering advanced treatments and surgeries.</p>
                                            </div>
                                            <NavLink to="/specialities/neurology-neurosurgery" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={OrthopaedicsImg} alt="Orthopaedic Icon" />
                                                </div>
                                                <h3>Orthopaedics</h3>
                                                <p>Advanced care for bone, joint, and spine conditions with minimally invasive
                                                    surgeries and tailored rehabilitation to restore mobility.</p>
                                            </div>
                                            <NavLink to="/specialities/orthopaedics" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={urologyImg} alt="Urology Icon" />
                                                </div>
                                                <h3>Urology</h3>
                                                <p>Specialised treatment for urinary and reproductive health issues.</p>
                                            </div>
                                            <NavLink to="/specialities/urology" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={emergencyImg} alt="Spine Care Icon" />
                                                </div>
                                                <h3>Emergency Medicine and
                                                    Critical Care</h3>
                                                <p>24/7 emergency care with immediate life-saving interventions, supported by
                                                    advanced equipment and a dedicated critical care team.</p>
                                            </div>
                                            <NavLink to="/specialities/emergency-medicines-critical-care" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="card-end">
                                            <div className="card-end-body">
                                                <div className="cardi-img">
                                                    <img src={gastroImg} alt="ENT Icon" />
                                                </div>
                                                <h3>Gastroenterology</h3>
                                                <p>Expert care for digestive and liver disorders using advanced treatments.</p>
                                            </div>
                                            <NavLink to="/specialities/gastro-intestinal-science" className="btn with-arr with-arr">Read More <img src={BlackArrow}
                                                alt="" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div> */}
                        <div className="spec-card homeSpace">
                            {isMobile ? (
                                <Swiper
                                    modules={[Autoplay]}
                                    spaceBetween={16}
                                    slidesPerView={1.2}
                                    autoplay={{ delay: 2500 }}
                                    loop={true}
                                >
                                    {homeSpecialties.map((item) => (
                                        <SwiperSlide key={item.specialty_id}>
                                            <div className="card-end">
                                                <div className="card-end-body">
                                                    <div className="cardi-img">
                                                        <img src={`${baseImage_path}/${item.specialty_icon}`} alt={item.specialty_name} />
                                                    </div>
                                                    <h3>{item.specialty_name}</h3>
                                                    <p>{item.specialty_description}</p>
                                                </div>
                                                <NavLink
                                                    to={`/specialities/${item.specialty_name.toLowerCase().replace(/\s+/g, '-').replace(/[&]+/g, 'and')}`}
                                                    className="btn with-arr with-arr"
                                                >
                                                    Read More <img src={BlackArrow} alt="" />
                                                </NavLink>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            ) : (
                                <div className="row">
                                    {homeSpecialties.map((item) => (
                                        <div key={item.specialty_id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                            <div className="card-end">
                                                <div className="card-end-body">
                                                    <div className="cardi-img">
                                                        <img src={`${baseImage_path}/${item.specialty_icon}`} alt={item.specialty_name} />
                                                    </div>
                                                    <h3>{item.specialty_name}</h3>
                                                    {/* <p>{item.specialty_description}</p> */}
                                                    <p dangerouslySetInnerHTML={{ __html: item.specialty_description }} />
                                                </div>
                                                <NavLink
                                                    to={`/specialities/${item.specialty_name.toLowerCase().replace(/\s+/g, '-').replace(/[&]+/g, 'and')}`}
                                                    className="btn with-arr with-arr"
                                                >
                                                    Read More <img src={BlackArrow} alt="" />
                                                </NavLink>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="view-all clrchng">
                            <NavLink to="/specialities">View All</NavLink>
                        </div>
                    </div>
                </div>
            </section>

            {/* Corporate Empanelled */}
            <section className="section corparate">
                <h2 className="section-title"><span>Corporate Empanelled</span></h2>
                <div className="corp-slid">
                    <Swiper
                        key={corporateLogos.length}
                        modules={[Autoplay]}
                        slidesPerView={isMobile ? 2 : 5}
                        spaceBetween={20}
                        centeredSlides={true}
                        loop={true}
                        autoplay={{
                            delay: 1,
                            disableOnInteraction: false,
                        }}
                        speed={5000}
                    >
                        {corporateLogos.map((logo, index) => (
                            <SwiperSlide
                                key={index}
                                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                            >
                                <img
                                    src={`${baseImage_path}/${logo.logo}`}
                                    alt={logo.name || `Corporate Logo ${index + 1}`}
                                    style={{ maxWidth: "120px", maxHeight: "60px", objectFit: "contain" }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                {/* TPA Empanelled */}
                <h2 className="section-title"><span>TPA Empanelled</span></h2>
                <div className="corp-slid">
                    <Swiper
                        modules={[Autoplay]}
                        slidesPerView={isMobile ? 2 : 5}
                        spaceBetween={20}
                        centeredSlides={true}
                        loop={true}
                        autoplay={{
                            delay: 1,
                            disableOnInteraction: false,
                            reverseDirection: true,
                        }}
                        speed={5000}
                    >
                        {tpaLogos.map((logo, index) => (
                            <SwiperSlide
                                key={index}
                                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                            >
                                <img
                                    src={`${baseImage_path}/${logo.logo}`}
                                    alt={logo.name || `TPA Logo ${index + 1}`}
                                    style={{ maxWidth: "120px", maxHeight: "60px", objectFit: "contain" }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="view-all">
                    <NavLink to="/corporate-tpa">View All</NavLink>
                </div>
            </section>

            <section className="section expert-doctors">
                <h2 className="section-title"><span>Our Expert Doctors</span></h2>
                <div className="cust-container">
                    {/* <div className="doctor-box">
                        {isMobile ? (
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={16}
                                slidesPerView={1.1}
                                autoplay={{ delay: 2500 }}
                                loop={true}
                            >
                                {[
                                    {
                                        name: "Dr. Arun Bal",
                                        specialty: "Diabetologist",
                                        img: Doct1,
                                        profile: "/doctor/arun-bal",
                                        experience: "30+ yrs",
                                    },
                                    {
                                        name: "Dr. Suresh Advani",
                                        specialty: "Oncologist",
                                        img: Doct2,
                                        profile: "/doctor",
                                        experience: "50+ yrs",
                                    },
                                    {
                                        name: "Dr. Haresh Mehta",
                                        specialty: "Cardiologist",
                                        img: Doct3,
                                        profile: "/doctor/haresh-mehta",
                                        experience: "20+ yrs",
                                    },
                                    {
                                        name: "Dr. Vinay Dhir",
                                        specialty: "Gastroenterologist",
                                        img: Doct4,
                                        profile: "/doctor",
                                        experience: "30+ yrs",
                                    },
                                ].map((doc, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="oueextpert-cardiolo-item">
                                            <div className="cardiolo-item-img">
                                                <img src={doc.img} alt={doc.name} />
                                            </div>
                                            <div className="cardiolo-itemdesc">
                                                <div className="drs-design">
                                                    <span>{doc.specialty}</span>
                                                    <NavLink to={doc.profile} style={{ color: "#0ca854" }}>View Profile</NavLink>
                                                </div>
                                                <div className="drs-title">
                                                    <h4>{doc.name}</h4>
                                                    <div className="drs-title-shareicn">
                                                        <img src={VectorIcon} alt="Share Icon" style={{ cursor: "pointer" }} />
                                                    </div>
                                                </div>
                                                <p>Total Experience - {doc.experience}</p>
                                                <div className="drs-bookapp-cta common-roundcta">
                                                    <NavLink to={doc.profile} className="btn without-color btnhv">Book Appointment</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <div className="row">
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                    <div className="oueextpert-cardiolo-item">
                                        <div className="cardiolo-item-img">
                                            <img src={Doct1} alt="Dr. Arun Bal" />
                                        </div>
                                        <div className="cardiolo-itemdesc">
                                            <div className="drs-design">
                                                <span>Diabetologist</span>
                                                <NavLink to="/doctor/arun-bal" style={{ color: "#0ca854" }}>View Profile</NavLink>
                                            </div>

                                            <div className="drs-title">
                                                <h4>Dr. Arun Bal</h4>
                                                <div className="drs-title-shareicn">
                                                    <img src={VectorIcon} alt="Share Icon"
                                                        style={{ cursor: "pointer" }} />
                                                </div>
                                            </div>
                                            <p>Total Experience - 30+ yrs</p>
                                            <div className="drs-bookapp-cta common-roundcta">
                                                <NavLink to="/doctor/arun-bal" className="btn without-color btnhv">Book Appointment</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                    <div className="oueextpert-cardiolo-item">
                                        <div className="cardiolo-item-img">
                                            <img src={Doct2} alt="Dr. Suresh Advani" />
                                        </div>
                                        <div className="cardiolo-itemdesc">
                                            <div className="drs-design">
                                                <span>Oncologist</span>
                                                <NavLink to="/doctor" style={{ color: "#0ca854" }}>View Profile</NavLink>
                                            </div>

                                            <div className="drs-title">
                                                <h4>Dr. Suresh Advani</h4>
                                                <div className="drs-title-shareicn">
                                                    <img src={VectorIcon} alt="Share Icon"
                                                        style={{ cursor: "pointer" }} />
                                                </div>
                                            </div>
                                            <p>Total Experience - 50+ yrs</p>
                                            <div className="drs-bookapp-cta common-roundcta">
                                                <NavLink to="/doctor/haresh-mehta" className="btn without-color btnhv">Book Appointment</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                    <div className="oueextpert-cardiolo-item">
                                        <div className="cardiolo-item-img">
                                            <img src={Doct3} alt="Dr. Haresh Mehta" />
                                        </div>
                                        <div className="cardiolo-itemdesc">
                                            <div className="drs-design">
                                                <span>Cardiologist</span>
                                                <NavLink to="/doctor/haresh-mehta" style={{ color: "#0ca854" }}>View Profile</NavLink>
                                            </div>

                                            <div className="drs-title">
                                                <h4>Dr. Haresh Mehta</h4>
                                                <div className="drs-title-shareicn">
                                                    <img src={VectorIcon} alt="Share Icon"
                                                        style={{ cursor: "pointer" }} />
                                                </div>
                                            </div>
                                            <p>Total Experience - 20+ yrs</p>
                                            <div className="drs-bookapp-cta common-roundcta">
                                                <NavLink to="/doctor" className="btn without-color btnhv">Book Appointment</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                    <div className="oueextpert-cardiolo-item">
                                        <div className="cardiolo-item-img">
                                            <img src={Doct4} alt="Dr. Vinay Dhir" />
                                        </div>
                                        <div className="cardiolo-itemdesc">
                                            <div className="drs-design">
                                                <span>Gastroenterologist</span>
                                                <NavLink to="/doctor" style={{ color: "#0ca854" }}>View Profile</NavLink>
                                            </div>

                                            <div className="drs-title">
                                                <h4>Dr. Vinay Dhir</h4>
                                                <div className="drs-title-shareicn">
                                                    <img src={VectorIcon} alt="Share Icon"
                                                        style={{ cursor: "pointer" }} />
                                                </div>
                                            </div>
                                            <p>Total Experience - 30+ yrs</p>
                                            <div className="drs-bookapp-cta common-roundcta">
                                                <NavLink to="/doctor" className="btn without-color btnhv">Book Appointment</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div> */}
                    <div className="doctor-box">
                        {isMobile ? (
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={16}
                                slidesPerView={1.1}
                                autoplay={{ delay: 2500 }}
                                loop={true}
                            >
                                {homeDoctors.map((doc) => (
                                    <SwiperSlide key={doc.doctor_id}>
                                        <div
                                            className="oueextpert-cardiolo-item"
                                            onClick={() => navigate(`/doctor/${doc.slug.toLowerCase().replace(/\s+/g, "-")}`)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <div className="cardiolo-item-img">
                                                <img
                                                    src={doc.doctor_img ? `${baseImage_path}/${doc.doctor_img}` : "/default-doctor-image.jpg"}
                                                    alt={doc.doctor_name}
                                                />
                                            </div>
                                            <div className="cardiolo-itemdesc">
                                                <div className="drs-design">
                                                    <span>{doc.specialty_name}</span>
                                                    <NavLink to={`/doctor/${doc.slug.toLowerCase().replace(/\s+/g, "-")}`} style={{ color: "#0ca854" }} onClick={(e) => e.stopPropagation()}>
                                                        View Profile
                                                    </NavLink>
                                                </div>
                                                <div className="drs-title">
                                                    <h4>{doc.name_prefix} {doc.doctor_name}</h4>
                                                    <div className="drs-title-shareicn">
                                                        <img
                                                            src={VectorIcon}
                                                            alt="Share Icon"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={(e) => { e.stopPropagation(); handleShare(doc); }}
                                                        />
                                                    </div>
                                                </div>
                                                <p>Total Experience - {doc.total_experience} yrs</p>
                                                <div className="drs-bookapp-cta common-roundcta">
                                                    <button type="button" className="btn without-color btnhv" onClick={(e) => { e.stopPropagation(); setAppointmentDoctor({ id: doc.doctor_id, name: doc.doctor_name, specialityId: doc.specialty_id, specialityName: doc.specialty_name }); }}>
                                                        Book Appointment
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <div className="row">
                                {homeDoctors.map((doc) => (
                                    <div key={doc.doctor_id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div
                                            className="oueextpert-cardiolo-item"
                                            onClick={() => navigate(`/doctor/${doc.slug.toLowerCase().replace(/\s+/g, "-")}`)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <div className="cardiolo-item-img">
                                                <img
                                                    src={doc.doctor_img ? `${baseImage_path}/${doc.doctor_img}` : "/default-doctor-image.jpg"}
                                                    alt={doc.doctor_name}
                                                />
                                            </div>
                                            <div className="cardiolo-itemdesc">
                                                <div className="drs-design">
                                                    <span>{doc.specialty_name}</span>
                                                    <NavLink to={`/doctor/${doc.slug.toLowerCase().replace(/\s+/g, "-")}`} style={{ color: "#0ca854" }} onClick={(e) => e.stopPropagation()}>
                                                        View Profile
                                                    </NavLink>
                                                </div>
                                                <div className="drs-title">
                                                    <h4>{doc.name_prefix} {doc.doctor_name}</h4>
                                                    <div className="drs-title-shareicn">
                                                        <img src={VectorIcon} alt="Share" style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); handleShare(doc); }} />
                                                    </div>
                                                </div>
                                                <p>Total Experience - {doc.total_experience} yrs</p>
                                                <div className="drs-bookapp-cta common-roundcta">
                                                    <button type="button" className="btn without-color btnhv" onClick={(e) => { e.stopPropagation(); setAppointmentDoctor({ id: doc.doctor_id, name: doc.doctor_name, specialityId: doc.specialty_id, specialityName: doc.specialty_name }); }}>
                                                        Book Appointment
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="view-all">
                    <NavLink to="/doctor">View All</NavLink>
                </div>
            </section>

            <PatientTech />

            <PatientStory />

            <section className="section dot-background">
                <div className="cust-container">
                    <div className="custom-background">
                        <div className="map-right">
                            {/* <!-- <p>Beyond Boundaries</p> --> */}
                            <h4>Transforming Lives<br />
                                <span>Worldwide For Over 45 Years</span>
                            </h4>
                            <div className="map-right-cta">
                                <NavLink to="/international-patients">Enquire Now</NavLink>
                            </div>

                        </div>
                        <div className="map-left">
                            <div className="map-leftimg">
                                <img src={map} alt="" />
                            </div>

                            <div className="plus-data">
                                <div className="avrage">
                                    <h4>200+</h4>
                                    <p>Beds</p>
                                </div>
                                <div className="avrage">
                                    <h4>300+</h4>
                                    <p>Doctors</p>
                                </div>
                                <div className="avrage">
                                    <h4>24/7</h4>
                                    <p>Emergency Care</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            < InformationEvents />

            {/* Modal for patient form */}
            {
                showModal && (
                    <div
                        className="modal fade custmodal-width custom-modalwdth2 show"
                        style={{ display: "block" }}
                        id="patienform"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalCenterTitle"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modalclosebtn">
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={handleCloseModal}
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="intern-form-inner">
                                        <h5>Request A Call Back Form:</h5>
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group row">
                                                <div className="col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="patient_name">
                                                            Full Name of the Patient <span>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="patient_name"
                                                            name="patient_name"
                                                            value={formData.patient_name}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                {/* <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="countryCode">
                                                            Country Code <span>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="countryCode"
                                                            name="countryCode"
                                                            value={formData.countryCode}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="contact_number">
                                                            Contact No <span>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="contact_number"
                                                            name="contact_number"
                                                            value={formData.contact_number}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="email">Email</label>
                                                        <input
                                                            type="email"
                                                            id="email"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="speciality">Speciality <span>*</span></label>
                                                        {/* <select
                                                            id="speciality"
                                                            name="speciality"
                                                            value={formData.speciality_id}
                                                            onChange={handleSpecialtyList}
                                                        >
                                                            <option value="">Please select Speciality</option>
                                                            {specialties.map((specialty) => (
                                                                <option key={specialty.id} value={specialty.id}>
                                                                    {specialty.name}
                                                                </option>
                                                            ))}
                                                        </select> */}
                                                        <select
                                                            id="speciality"
                                                            name="speciality"
                                                            value={formData.speciality_id}
                                                            onChange={handleSpecialtyList}
                                                        >
                                                            <option value="">Please select Speciality</option>
                                                            {specialties.map((specialty) => (
                                                                <option key={specialty.id} value={specialty.id}>
                                                                    {specialty.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="doctor">Select Doctor <span>*</span></label>
                                                        {/* <select
                                                            id="doctor"
                                                            name="doctor"
                                                            value={formData.doctor_id}
                                                            // onChange={(e) => setFormData({ ...formData, doctor: e.target.value })}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    doctor: parseInt(e.target.value),
                                                                }))
                                                            }
                                                        >
                                                            <option value="">Please select Doctor</option>
                                                            {doctorsList.map((doctor) => (
                                                                <option key={doctor.id} value={doctor.id}>
                                                                    {doctor.doctor_name}
                                                                </option>
                                                            ))}
                                                        </select> */}
                                                        <select
                                                            id="doctor"
                                                            name="doctor"
                                                            value={formData.doctor_id}
                                                            onChange={(e) => {
                                                                const selectedId = parseInt(e.target.value);
                                                                const selectedDoc = doctorsList.find(doc => parseInt(doc.id) === selectedId);
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    doctor_id: selectedId,
                                                                    doctor_name: selectedDoc?.doctor_name || "",
                                                                }));
                                                            }}                                                    >
                                                            <option value="">Please select Doctor</option>
                                                            {doctorsList.map((doctor) => (
                                                                <option key={doctor.id} value={doctor.id}>
                                                                    {doctor.doctor_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="date">Please Select Date <span>*</span></label>
                                                        <input
                                                            type="date"
                                                            id="date"
                                                            name="date"
                                                            value={formData.date}
                                                            onChange={handleInputChange}
                                                            min={new Date().toISOString().split("T")[0]}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12">
                                                    <div className="int-form-item">
                                                        <label htmlFor="message">Message</label>
                                                        <textarea
                                                            id="message"
                                                            name="message"
                                                            value={formData.message}
                                                            onChange={handleInputChange}
                                                            rows="5"
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-12">
                                                    <div className="int-form-item">
                                                        <button type="submit">
                                                            <img src={newArrImg} alt="" />
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default HomePage;
